module.exports = "{ &quot;name&quot;: &quot;InstantBookingSpinner&quot;, &quot;main&quot;: &quot;./InstantBookingSpinner.js&quot; }"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/InstantBookingSpinner/package.json
// module id = 645
// module chunks = 0